var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedNowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 0L73.106 17.625L94.4732 11.3635L95.121 33.6198L116.088 41.1135L103.53 59.5L116.088 77.8865L95.121 85.3802L94.4732 107.637L73.106 101.375L59.5 119L45.894 101.375L24.5268 107.637L23.879 85.3802L2.91214 77.8865L15.47 59.5L2.91214 41.1135L23.879 33.6198L24.5268 11.3635L45.894 17.625L59.5 0Z",
    fill: "#FFE236"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8117 9.96875L71.2094 24.7331L89.1086 19.4879L89.6513 38.1319L107.215 44.4094L96.6954 59.8117L107.215 75.214L89.6513 81.4914L89.1086 100.135L71.2094 94.8902L59.8117 109.655L48.414 94.8902L30.5147 100.135L29.9721 81.4914L12.4082 75.214L22.9279 59.8117L12.4082 44.4094L29.9721 38.1319L30.5147 19.4879L48.414 24.7331L59.8117 9.96875Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4841 60.9875L39.3712 60.0737L50.6908 71.7351L52.4847 73.5831L54.2785 71.7351L80.6288 44.5893L81.5159 45.5031L52.4847 75.4107L38.4841 60.9875Z",
    fill: "#FFE236",
    stroke: "#FFE236",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedNowIcon);
export default __webpack_public_path__ + "static/media/verified-now-icon.49999f767f24772061388e5a0806e4da.svg";
export { ForwardRef as ReactComponent };